{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Výběr barvy",
  "colorSwatch": "barevný vzorek",
  "transparent": "průhledný",
  "twoDimensionalSlider": "2D posuvník"
}
